module.exports = "/_next/static/images/aditya-80789d329926938e31174fafb3977464.png";